export const isEnvDev = process.env.NODE_ENV === 'development';
export const isEnvSSR = typeof window === 'undefined';
